import parsePhoneNumber from 'libphonenumber-js';

export function parseNumber(number) {
  try {
    return parsePhoneNumber(number);
  } catch (_) {
  }
}

export function getCountryFromPhone(number) {
  if (!number) return "";
  
  const phone = parseNumber(number);

  return phone?.country || "";
}